// extracted by mini-css-extract-plugin
export default {"clinicServices":"clinicServices_clinicServices__Q2VQ-"};